import React from 'react';
import { Mathround } from './Mathround';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

class UpgradeItem extends React.Component {
  clickHandler = () => {
    let { data } = this.props,
      { redux } = this.props;
    redux.removeCoinsAction(data.currentCost);
    redux.upgradeItemAction(data);
  };

  render() {
    const { data } = this.props;
    return (
      <button
        onClick={this.clickHandler}
        className="upgrade__button"
        href="#upgrade"
        disabled={this.props.disabled}
      >
        <span className="upgrade__button-name">{data.name}</span>
        <span className="upgrade__button-description">{data.description}</span>
        {data.currentLevel < data.maxLevels ? (
          <span className="upgrade__button-holder">
            <span className="upgrade__button-level">
              <KeyboardArrowUpIcon />
              {data.currentLevel}
            </span>
            <span className="upgrade__button-cost">
              <AttachMoneyIcon />
              <span>{Mathround(data.currentCost, 2)}</span>
            </span>
          </span>
        ) : (
          <span className="upgrade__button-cost">MAXED OUT</span>
        )}
      </button>
    );
  }
}

export { UpgradeItem };
